import script from "./ServiceExemptionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceExemptionModal.vue?vue&type=script&setup=true&lang=js"

import "./ServiceExemptionModal.vue?vue&type=style&index=0&id=313b6e11&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-313b6e11"]])

export default __exports__